import * as React from 'react';
import { DriveFileRenameOutline } from '@mui/icons-material';
import { useAuth } from '../../../../contexts';
import {
  ApplicationViewList,
  type ApplicationViewListProps,
  type TableColumns,
  type FilterFields,
  type CustomAction,
  type ApplicationViewTableDataItem,
} from '../../../Application/components/ApplicationViewList';
import { dorpgsToDoFilter, dorpgsOverViewFilter } from './filters';
import { APPLICATION_STATUS_TYPE } from '../../../../utils';
import { ASSESSMENT_MODULE } from '../../components';

export const DepartmentApplicationList: React.FunctionComponent = () => {
  const { user } = useAuth();

  const handleEditAssessment = (row: ApplicationViewTableDataItem): void => {
    const { applicationId, isInterviewCompleted } = row;
    const am = isInterviewCompleted
      ? ASSESSMENT_MODULE.EVALUATION
      : ASSESSMENT_MODULE.DORPGS_ASSESSMENT;
    // TODO seems am not work
    window.open(
      `/internal/dorpgs-homepage/dorpgsassessment/details/${applicationId}/?am=${am}`,
    );
  };

  const customActions: CustomAction[] = [
    {
      icon: <DriveFileRenameOutline />,
      handleAction: handleEditAssessment,
      checkDisable: row => {
        const status = row.applicationStatusRaw;
        return !(status === APPLICATION_STATUS_TYPE.UNDER_DORPGS);
      },
    },
  ];

  const hiddenFilters: FilterFields[] = React.useMemo(
    () => [
      'department',
      'partnerCategory',
      'applicantIdentityType',
      'applicantLocalIndicator',
      'gsAssignee',
    ],
    [],
  );

  const listFilter = dorpgsOverViewFilter(user);

  const visibleColumns: TableColumns[] = React.useMemo(
    () => [
      'applicationNo',
      'applicantName',
      'entryYear',
      'applyProgramme',
      'researchAreas',
      'scholarshipApplications',
      'hkpfsDisplayInformation',
      'nominatedFundings',
      'applicationSubmissionTime',
      'nominationSubmissionTime',
      'applicationStatus',
    ],
    [],
  );

  const quickFilters = [
    {
      id: 'TO_DO',
      text: 'TO-DO',
      filter: dorpgsToDoFilter(user),
      isDefault: true,
    },
    { id: 'ALL', text: 'ALL', filter: dorpgsOverViewFilter(user) },
  ];

  const filterProps: ApplicationViewListProps['filterProps'] = {
    hiddenFilterFields: hiddenFilters,
  };
  const tableProps: ApplicationViewListProps['tableProps'] = {
    initialVisibleColumns: visibleColumns,
    listFilter,
    customActions,
  };
  const quickFilterProps: ApplicationViewListProps['quickFilterProps'] = {
    quickFilters,
  };

  return (
    <ApplicationViewList
      tableProps={tableProps}
      filterProps={filterProps}
      quickFilterProps={quickFilterProps}
    />
  );
};
